import { ArrowSquareOut } from "@phosphor-icons/react";
import { Text } from "@radix-ui/themes";

interface SourceLinkBlockProps {
  title: string;
  url: string;
  linkType?: string;
}

export function SourceLinkBlock({
  title,
  url,
  linkType,
}: SourceLinkBlockProps) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1.5 rounded-md border border-puntt-neutral-gray-5 bg-puntt-neutral-gray-2 px-2.5 py-1 text-puntt-accent-11 transition-colors hover:bg-puntt-neutral-gray-3"
    >
      <Text size="1" as="span">
        {title}
      </Text>
      {linkType && (
        <Text size="1" as="span" className="text-puntt-neutral-gray-9">
          ({linkType})
        </Text>
      )}
      <ArrowSquareOut size={12} />
    </a>
  );
}
